<mat-card
  id="procedures-card"
  class="has-progress-bar"
  [ngClass]="{
    'card-table': (loading$ | async) === false,
    default: (loading$ | async) === true,
  }"
>
  <mat-progress-bar [mode]="(loading$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>
  <mat-card-title
    *appHasPermission="'appointment.edit'"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <span>{{ 'procedures-card.title' | translate }}</span>
  </mat-card-title>

  <ng-container *ngIf="(studies$ | async) as studies; else loading">
    <mat-card-content *ngIf="studies?.length > 0; else noProducts" fxLayout="column">
      <table mat-table [dataSource]="studies">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'procedures-card.table.procedure' | translate }}
          </th>
          <td mat-cell *matCellDef="let study">
            <ng-container *ngIf="editable; else noEditPermission">
              <button *appHasPermission="'setting.edit'; else noEditPermission"
                mat-flat-button
                [matTooltip]="'procedures-card.table.procedure-action' | translate"
                (click)="openEditProduct(study)">
                {{ study.productName }}
              </button>
            </ng-container>
            <ng-template #noEditPermission>
              {{ study.productName }}
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="eid">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'procedures-card.table.eid' | translate }}
          </th>
          <td mat-cell *matCellDef="let study">
            {{ study.eid }}
          </td>
        </ng-container>

        <ng-container matColumnDef="procedureCodes">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'procedures-card.table.procedureCodes' | translate }}
          </th>
          <td mat-cell *matCellDef="let study">
            {{ study.productCodes?.join(', ') }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-card-content>
  </ng-container>

  <ng-template #loading>
    <mat-card-content fxLayout="column">
      <p>
        {{ 'common.loading' | translate }}…
      </p>
    </mat-card-content>
  </ng-template>

  <ng-template #noProducts>
    <mat-card-content fxLayout="column">
      <p>
        {{ 'procedures-card.no-procedures' | translate }}
      </p>
    </mat-card-content>
  </ng-template>
</mat-card>
